import { BLOG_FILTERS } from '@/features/blog/constants/blog-filters'
import { BLOG_ACTIVE_PILL } from '@/features/blog/constants/blog.constants'
import type { BlogFilterId } from '@/features/blog/types/blog.types'
import { Button } from '@/shared/components/ui/Button'
import { cn } from '@/shared/lib/utils'

export function BlogCategoryFilters({
  activeFilter,
  onFilterChange,
}: {
  activeFilter: BlogFilterId
  onFilterChange: (id: BlogFilterId) => void
}) {
  return (
    <div
      className={cn(
        'mt-8 sm:mt-10',
        'scrollbar-hide -mx-4 overflow-x-auto overflow-y-hidden px-4 [-webkit-overflow-scrolling:touch] sm:mx-0 sm:px-0',
      )}
    >
      <div className="flex w-max max-w-none flex-nowrap items-center gap-2 pb-1">
        {BLOG_FILTERS.map(({ id, label }) => {
          const active = activeFilter === id
          return (
            <Button
              key={id}
              type="button"
              variant="outline"
              size="sm"
              className={cn(
                'shrink-0 rounded-full border-neutral-300 px-4 py-2 text-sm font-medium shadow-none transition-colors',
                active ? BLOG_ACTIVE_PILL : 'bg-white text-neutral-800 hover:bg-neutral-50',
              )}
              onClick={() => onFilterChange(id)}
            >
              {label}
            </Button>
          )
        })}
      </div>
    </div>
  )
}
